import DateRangeInput from "components/customInputs/DateRangeInput";

import {
  DateRangeFiltersState,
  FilterLabels,
} from "../casesTable/CaseAdminFilters.contracts";

type DateRangeFiltersProps = DateRangeFiltersState & {
  onChangeDateRange: Function;
};

const dateInputLabel = {
  receivedDate: "Date Received",
  collectedDate: "Date Collected",
  accessionCompleted: "Accessioned Date",
  finalizedAt: "Finalized Date",
};

export const mapDateRangeFilterToLabel = Object.entries(dateInputLabel).reduce(
  (acc, [key, value]) => ({
    ...acc,
    [`${key}Before`]: `${value} - Before`,
    [`${key}After`]: `${value} - After`,
  }),
  {} as FilterLabels<DateRangeFiltersState>
);

const DateRangeFilters = (props: DateRangeFiltersProps) => {
  return (
    <>
      <DateRangeInput
        id="case_receivedDate"
        label={dateInputLabel.receivedDate}
        values={{
          from: {
            id: "receivedDateAfter",
            name: "received_date_after",
            value: props.receivedDateAfter,
          },
          to: {
            id: "receivedDateBefore",
            name: "received_date_before",
            value: props.receivedDateBefore,
          },
        }}
        onChangeDate={props.onChangeDateRange}
        isClearable
      />
      <DateRangeInput
        id="case_collectedDate"
        label={dateInputLabel.collectedDate}
        values={{
          from: {
            id: "collectedDateAfter",
            name: "collected_date_after",
            value: props.collectedDateAfter,
          },
          to: {
            id: "collectedDateBefore",
            name: "collected_date_before",
            value: props.collectedDateBefore,
          },
        }}
        onChangeDate={props.onChangeDateRange}
        isClearable
      />
      <DateRangeInput
        id="accessionCompleted"
        label={dateInputLabel.accessionCompleted}
        values={{
          from: {
            id: "accessionCompletedAfter",
            name: "accession_completed_after",
            value: props.accessionCompletedAfter,
          },
          to: {
            id: "accessionCompletedBefore",
            name: "accession_completed_before",
            value: props.accessionCompletedBefore,
          },
        }}
        onChangeDate={props.onChangeDateRange}
        isClearable
      />
      <DateRangeInput
        id="finalizedAt"
        label={dateInputLabel.finalizedAt}
        values={{
          from: {
            id: "finalizedAtAfter",
            name: "finalized_at_after",
            value: props.finalizedAtAfter,
          },
          to: {
            id: "finalizedAtBefore",
            name: "finalized_at_before",
            value: props.finalizedAtBefore,
          },
        }}
        onChangeDate={props.onChangeDateRange}
        isClearable
      />
    </>
  );
};

export default DateRangeFilters;
